/* ============================================================
   SOUTH OF HEAVEN — Product Page JS
   Stoq / Restock Rocket compatible:
   - Does NOT intercept form submit (Stoq handles preorder submission)
   - Calls window._RestockRocket.renderButtonForVariant(id) on variant change
   - Fires standard Shopify variant:change custom event
   - Uses name="add" + class="product-form__submit" on the button
   ============================================================ */
(function () {
  'use strict';

  function initSOHProduct() {
    var pdp = document.querySelector('.soh-pdp');
    if (!pdp) return;

    var form          = document.getElementById('SohProductForm');
    var nativeSelect  = document.getElementById('SohNativeVariantSelect');
    var addBtn        = document.getElementById('SohAddToCart');
    var addText       = document.getElementById('SohAddToCartText');

    /* ── Gallery thumbnails ─────────────────────────────────── */
    var thumbs   = pdp.querySelectorAll('.soh-a-thumb');
    var mainImg  = pdp.querySelector('#SohMainImg');
    var imgIdx   = pdp.querySelector('#SohImgIdx');
    var mainWrap = pdp.querySelector('.soh-a-main');

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          mainImg.dataset.fullSrc = thumb.dataset.fullSrc || thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || '';
        }
        if (mainWrap) mainWrap.classList.toggle('cover', thumb.dataset.fit === 'cover');
        if (imgIdx) {
          var total = String(thumbs.length).padStart(2, '0');
          imgIdx.textContent = String(i + 1).padStart(2, '0') + ' / ' + total;
        }
      });
    });

    /* ── Zoom lightbox ──────────────────────────────────────── */
    var zoomBtn     = pdp.querySelector('.soh-a-zoom');
    var zoomOverlay = document.getElementById('SohZoomOverlay');
    var zoomImg     = document.getElementById('SohZoomImg');
    var zoomClose   = document.getElementById('SohZoomClose');

    function openZoom() {
      if (!zoomOverlay || !mainImg) return;
      if (zoomImg) zoomImg.src = mainImg.dataset.fullSrc || mainImg.src;
      zoomOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeZoom() {
      if (zoomOverlay) zoomOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    if (zoomBtn)     zoomBtn.addEventListener('click', openZoom);
    if (mainImg)     mainImg.addEventListener('dblclick', openZoom);
    if (zoomClose)   zoomClose.addEventListener('click', closeZoom);
    if (zoomOverlay) zoomOverlay.addEventListener('click', function (e) {
      if (e.target === zoomOverlay) closeZoom();
    });

    /* ── Size guide modal ───────────────────────────────────── */
    var sgBtn   = pdp.querySelector('#SohSizeGuideBtn');
    var sgModal = pdp.querySelector('#SohSizeGuideModal');
    var sgClose = pdp.querySelector('#SohSizeGuideClose');

    function closeSizeGuide() {
      if (sgModal) sgModal.classList.remove('open');
      document.body.style.overflow = '';
    }
    if (sgBtn && sgModal) {
      sgBtn.addEventListener('click', function () {
        sgModal.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
      if (sgClose) sgClose.addEventListener('click', closeSizeGuide);
      sgModal.addEventListener('click', function (e) {
        if (e.target === sgModal) closeSizeGuide();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeZoom(); closeSizeGuide(); }
    });

    /* ── Color chips ────────────────────────────────────────── */
    var colorChips  = pdp.querySelectorAll('.soh-color-chip');
    var colorNameEl = pdp.querySelector('#SohColorName');

    colorChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        colorChips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        if (colorNameEl) colorNameEl.textContent = chip.dataset.value;
        updateVariant();
      });
    });

    /* ── Size buttons ───────────────────────────────────────── */
    var sizeBtns = pdp.querySelectorAll('.soh-size-btn:not(:disabled)');

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        updateVariant();
      });
    });

    /* ── Variant matching ───────────────────────────────────── */
    function updateVariant() {
      var selectedChip = pdp.querySelector('.soh-color-chip[aria-pressed="true"]');
      var selectedSize = pdp.querySelector('.soh-size-btn[aria-pressed="true"]');
      var colorVal = selectedChip ? selectedChip.dataset.value : null;
      var sizeVal  = selectedSize ? selectedSize.dataset.value  : null;

      var matchedId        = null;
      var matchedAvailable = false;
      var matchedPrice     = '';

      pdp.querySelectorAll('[data-soh-variant-id]').forEach(function (el) {
        var o1 = !colorVal || el.dataset.sohVariantOption1 === colorVal;
        var o2 = !sizeVal  || el.dataset.sohVariantOption2 === sizeVal;
        if (o1 && o2) {
          matchedId        = el.dataset.sohVariantId;
          matchedAvailable = el.dataset.sohVariantAvailable === 'true';
          matchedPrice     = el.dataset.sohVariantPrice;
        }
      });

      if (!matchedId) return;

      /* 1. Update the hidden select — this is what Stoq reads via [data-variant-id] */
      if (nativeSelect) {
        nativeSelect.value = matchedId;

        /* 2. Fire native 'change' event so Stoq and other apps detect the switch */
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* 3. Call Stoq's public API to re-render the preorder button for this variant */
      try {
        if (window._RestockRocket && typeof window._RestockRocket.renderButtonForVariant === 'function') {
          window._RestockRocket.renderButtonForVariant(parseInt(matchedId, 10));
        }
      } catch (e) { /* Stoq not active on this product */ }

      /* 4. Fire standard Shopify variant:change event (used by many apps) */
      document.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variantId: parseInt(matchedId, 10), available: matchedAvailable }
      }));

      /* 5. Update our own button — only if Stoq hasn't replaced it */
      if (addBtn && addText && document.getElementById('SohAddToCart')) {
        if (matchedAvailable) {
          addBtn.disabled = false;
          addText.innerHTML = (addBtn.dataset.addLabel || 'Add to cart') +
            ' <span class="soh-price-tail">/ ' + matchedPrice + '</span>';
        } else {
          addBtn.disabled = true;
          addText.textContent = addBtn.dataset.soldLabel || 'Sold Out';
        }
      }
    }

    /* ── AJAX add to cart (our button only, not Stoq's) ────── */
    /* We listen on button CLICK — not form submit — so we never
       block Stoq's own form submission handler.
       If Stoq has replaced our button, our click listener fires on
       a detached element and does nothing. */
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        /* If this button is no longer in the DOM (Stoq replaced it), bail */
        if (!document.getElementById('SohAddToCart')) return;

        e.preventDefault();

        var vid = nativeSelect ? nativeSelect.value : '';
        if (!vid) return;

        addBtn.disabled = true;
        if (addText) addText.textContent = 'Adding\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'Cart error');
          if (addText) addText.textContent = 'Added \u2713';
          setTimeout(function () {
            var label = addBtn.dataset.addLabel || 'Add to cart';
            var priceEl = pdp.querySelector('[data-soh-variant-id="' + vid + '"]');
            var price   = priceEl ? priceEl.dataset.sohVariantPrice : '';
            if (addText) addText.innerHTML = label + (price ? ' <span class="soh-price-tail">/ ' + price + '</span>' : '');
            addBtn.disabled = false;
          }, 1600);
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.setAttribute('data-cart-count', cart.item_count);
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {
          if (addBtn) addBtn.disabled = false;
          if (addText) addText.textContent = addBtn ? (addBtn.dataset.addLabel || 'Add to cart') : 'Add to cart';
        });
      });
    }

    /* ── Accordions ─────────────────────────────────────────── */
    pdp.querySelectorAll('.soh-acc-head').forEach(function (head) {
      head.addEventListener('click', function () {
        var row    = head.closest('.soh-acc-row');
        var isOpen = row.classList.contains('open');
        pdp.querySelectorAll('.soh-acc-row.open').forEach(function (r) { r.classList.remove('open'); });
        if (!isOpen) row.classList.add('open');
      });
    });

    /* Open first accordion by default */
    var firstAcc = pdp.querySelector('.soh-acc-row');
    if (firstAcc) firstAcc.classList.add('open');

    /* ── Init Stoq for current variant on page load ─────────── */
    try {
      if (nativeSelect && window._RestockRocket && typeof window._RestockRocket.renderButtonForVariant === 'function') {
        window._RestockRocket.renderButtonForVariant(parseInt(nativeSelect.value, 10));
      }
    } catch (e) { /* Stoq not active */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSOHProduct);
  } else {
    initSOHProduct();
  }
})();
